/**
 * Email one-time-code (OTP) sign-in — additive to Entra, for users on personal
 * devices the IdP blocks. Both endpoints are public (no auth header needed).
 */
import { apiCall } from '@/lib/api';

/** Request a code. Always resolves the same way (no account enumeration). In dev
 *  (stubbed email) the response carries `dev_code` so the flow is testable. */
export async function requestOtp(email: string): Promise<{ ok: boolean; dev_code?: string }> {
  return apiCall('/auth/otp/request', { method: 'POST', body: { email } });
}

/** Verify a code → an OTP session token to store as the bearer credential. */
export async function verifyOtp(email: string, code: string): Promise<{ token: string }> {
  return apiCall('/auth/otp/verify', { method: 'POST', body: { email, code } });
}
